import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import Box from '@mui/material/Box';

import { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { knowledgeCategorySelect, knowledgeCategoryDelete } from "../../../actions/knowledge_category";

import { useNavigate, useParams } from 'react-router-dom';
import { Link } from '@mui/material';

export default function CategoryView() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const category_idx  = useParams().category_idx;
    console.log("category_idx : ", category_idx);

    const initialCategoryState = {
        category_name: null
    };

    const [category, setCategory] = useState(initialCategoryState);

    const handleDeleteCategory = (event, idx) => {
        console.log(idx);
  
        if (window.confirm("정말 삭제하시겠습니까??") === true)   //확인
        {
          // 여기서 디스패치로~
          dispatch(knowledgeCategoryDelete(idx))
          .then(data => 
          {
              console.log("data : ", data);
          })
          .catch(e => {
              console.log(e);
          });
  
          navigate("/dashboard/KnowledgeCategoryList");  
        }
        else  //취소
        {
          return false;
        }
  
      };

    useEffect(() => {
        
        console.log("dispatch categorySelect");
        dispatch(knowledgeCategorySelect(category_idx))
        .then(data => 
        {
            console.log("data : ", data[0]);
            setCategory({category_name: data[0].kc_category_name});
        })
        .catch(e => {
            console.log(e);
        });

        return () => {      // 언마운트
            console.log("언마운트!");
        };

    }, [dispatch])

  return (
    <Card sx={{ minWidth: 275 }}>
      <CardContent>
        <Box
        sx={{
            '& > :not(style)': { m: 1, width: '400px' },
        }}
        >
        카테고리 이름 : {category.category_name || ''}
        </Box>
      </CardContent>
      <CardActions>
        <Link href={`/dashboard/KnowledgeCategoryList`} underline="none">목록</Link>
        <Link href={`/dashboard/KnowledgeCategoryModify/${category_idx}`} underline="none">수정</Link>
        <Link onClick={(e)=>handleDeleteCategory(e, category_idx)} value={category_idx} underline="none">삭제</Link>
      </CardActions>
    </Card>
  );
}